import React, { FC } from 'react'
import { Circle, Path, Svg, SvgProps } from 'react-native-svg'

const AaveIcon: FC<SvgProps> = ({ width = 28, height = 28 }) => {
  return (
    <Svg width={width} height={height} fill="none" viewBox="0 0 254 254">
      <Circle cx="127" cy="127" r="127" fill="#9391F7" />
      <Path
        fill="#fff"
        d="M103.39 133.194c10.89-1.768 18.285-12.03 16.518-22.92-1.768-10.89-12.03-18.285-22.92-16.518-10.89 1.768-18.285 12.029-16.518 22.92 1.768 10.89 12.03 18.285 22.92 16.518ZM155.603 133.194c10.89-1.768 18.285-12.03 16.517-22.92-1.767-10.89-12.029-18.285-22.919-16.518-10.89 1.768-18.286 12.029-16.518 22.92 1.768 10.89 12.029 18.285 22.92 16.518Z"
      />
      <Path
        fill="#fff"
        d="M126.262 31.012c-54.241 0-98.218 44.814-98.203 100.077h25.088c0-41.415 32.475-74.994 73.115-74.994 40.64 0 73.116 33.579 73.116 74.994h25.088c.009-55.263-43.967-100.077-98.204-100.077Z"
      />
    </Svg>
  )
}

export default React.memo(AaveIcon)
